import * as React from 'react';
export const IcBasketball = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M3.65 6.49A10 10 0 002.05 11h3.73a7.91 7.91 0 00-2.13-4.51zM2.05 13a10 10 0 001.6 4.51A7.91 7.91 0 005.78 13H2.05zM22 11a9.999 9.999 0 00-1.6-4.51A7.91 7.91 0 0018.22 11H22zm-2.93-6.07A9.93 9.93 0 0013 2.05v9h3.2a10 10 0 012.87-6.12zM4.93 19.07A9.93 9.93 0 0011 22v-9H7.8a10 10 0 01-2.87 6.07zm0-14.14A10 10 0 017.8 11H11V2.05a9.93 9.93 0 00-6.07 2.88zm15.42 12.58A9.998 9.998 0 0022 13h-3.78a7.91 7.91 0 002.13 4.51zM13 13v9a9.93 9.93 0 006.07-2.88A10 10 0 0116.2 13H13z'
      fill='currentColor'
    />
  </svg>
);
